import instance from "@/services/api";

export const revitBufferParamsAPI = {
  async getRevitBufferParamsList(params) {
    return await instance()
      .get(`project_list/floor_buffer/revit_data/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorField1(params) {
    return await instance()
      .get(`project_list/floor_buffer/get_floor_field_1/`, { params })
      .then((res) => res?.data);
  },
  async getFloorField2(params) {
    return await instance()
      .get(`project_list/floor_buffer/get_floor_field_2/`, { params })
      .then((res) => res?.data);
  },
  async getWallTypes(params) {
    return await instance()
      .get(`project_list/floor_buffer/wall_types/read/`, { params })
      .then((res) => res?.data);
  },
  async getParamType() {
    return await instance()
      .get(`/project_list/floor_params/type/read/`)
      .then((res) => res?.data);
  },
  async uploadRevitJson(body) {
    const formData = new FormData();
    formData.append("code", body.code);
    formData.append("revit_data", body.revit_data);
    return await instance()
      .post(`/project_list/floor_buffer/insert_polygon/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
};
